const liveServerStatus = true;

export default liveServerStatus;

